<template>
  <v-container fluid class="pa-6">
    <v-row>
      <v-col cols="12" class="d-flex align-center mb-6">
        <v-btn icon @click="$router.go(-1)" class="mr-4"><v-icon>mdi-arrow-left</v-icon></v-btn>

      </v-col>
    </v-row>
    
    <v-card outlined class="mt-2 mx-auto" style="border-radius: 4px; border: 1px solid #e0e0e0; box-shadow: none;" v-if="employees.length > 0">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left font-weight-bold py-4" style="color: #555; font-size: 14px;">Name</th>
              <th class="text-left font-weight-bold py-4" style="color: #555; font-size: 14px;">Employee Id</th>
              <th class="text-center font-weight-bold py-4" style="color: #555; font-size: 14px;">View Profile</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="emp in employees" :key="emp._id" class="hover-row">
              <td class="text-left py-3" style="color: #444; font-size: 15px;">{{ emp.name || 'Unnamed Employee' }}</td>
              <td class="text-left py-3" style="color: #444; font-size: 15px;">{{ emp.employeeId || 'N/A' }}</td>
              <td class="text-center py-3">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon color="#005f32" v-bind="attrs" v-on="on" @click.stop="viewGraph(emp._id)">
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>View Career Graph</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
    
    <v-row>
      <v-col v-if="employees.length === 0 && !loading" cols="12" class="text-center mt-10">
        <v-alert type="info" text>No employees assigned to this project or you lack permission to view them.</v-alert>
      </v-col>
      <v-col v-if="loading" cols="12" class="text-center mt-10">
        <v-progress-circular indeterminate color="#005f32"></v-progress-circular>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'CareerGraphEmployee',
  data() {
    return { 
      employees: [],
      loading: true,
      baseDocUrl: this.baseURL ? this.baseURL + 'u/' : 'http://localhost:5000/u/'
    };
  },
  async created() {
    await this.fetchEmployees();
  },
  methods: {
    async fetchEmployees() {
      try {
        const projectId = this.$route.params.projectId;
        const token = localStorage.getItem('token');
        const res = await axios.get('/career-graph/employees/' + projectId, { 
          headers: { 'x-auth-token': token } 
        });
        if (res.data.status) {
          this.employees = res.data.data;
        }
      } catch (e) {
        console.error("Error fetching employees:", e);
      } finally {
        this.loading = false;
      }
    },
    getDesignation(emp) {
      if(emp.positionid && emp.positionid.length > 0 && emp.positionid[0].name) {
         return emp.positionid[0].name;
      }
      return 'N/A';
    },
    viewGraph(employeeId) {
      this.$router.push({ name: 'CareerGraphView', params: { employeeId } });
    }
  }
};
</script>

<style scoped>
.hover-row {
  transition: background-color 0.2s ease;
}
.hover-row:hover {
  background-color: #f9f9f9;
  cursor: pointer;
}
</style>
